import createModelInstance from 'utils/createModelInstance';

const Vet = (vetObj = {}) => {
    let newVetObj = {
        id: '',
        name: '',
        skip: vetObj?.cstm && vetObj.cstm.provides_client_details_c == 0 ? true : false,
        hasPortalAccessC: vetObj?.cstm?.has_portal_access_c ?? false,
        pricingInformationC: vetObj?.cstm?.pricing_information_c ?? false,
        verRelationship: vetObj?.cstm?.relationship_type_c ?? false,
    };

    newVetObj = createModelInstance(newVetObj, vetObj);

    return {
        ...newVetObj,
        
        /**
         * Get the pricing information of the vet
         * 
         * @returns {String}
         */
        getPricingOption() {
            if (this.hasPortalAccessC && this.hasPortalAccessC === 'Yes' && this.pricingInformationC) {
                return this.pricingInformationC;
            }

            return "No price";
        },
    };
};

export default Vet;
